export default __webpack_public_path__ + "static/media/Home-section-5-02.8909e95e.png";